import { apiClient } from '../apiClient';

export interface DashboardStats {
  total_orgs: number;
  orgs_delta_30d: number;
  total_users: number;
  users_delta_7d: number;
  active_batches: number;
  pending_invites: number;
}

export interface SubmissionVerdictCount {
  verdict: string;
  count: number;
}

export interface SubmissionPeriodCount {
  period: string;
  count: number;
}

export interface SubmissionStats {
  total: number;
  by_verdict: SubmissionVerdictCount[];
  by_week: SubmissionPeriodCount[];
}

export interface TrainerFeedbackItem {
  id: string;
  rating: number;
  comment: string;
  student_id: string;
  student_name: string;
  trainer_id?: string;
  trainer_name: string;
  topic_id: string;
  topic_title: string;
  batch_id?: string;
  batch_name: string;
  created_at: string;
  updated_at: string;
}

export interface TrainerRatingSummary {
  trainer_id: string;
  trainer_name: string;
  avg_rating: number;
  count: number;
}

export interface BatchOption {
  batch_id: string;
  batch_name: string;
}

export interface FeedbackSummary {
  trainers: TrainerRatingSummary[];
  batches: BatchOption[];
}

export const dashboardApi = {
  getStats: async (): Promise<DashboardStats> => {
    const { data } = await apiClient.get('/api/v1/admin/dashboard/stats');
    return data as DashboardStats;
  },
  getSubmissionStats: async (): Promise<SubmissionStats> => {
    const { data } = await apiClient.get('/api/v1/admin/stats/submissions');
    return data as SubmissionStats;
  },
  getTrainerFeedback: async (filters?: { trainer_id?: string; batch_id?: string }): Promise<TrainerFeedbackItem[]> => {
    const params: Record<string, string> = {};
    if (filters?.trainer_id) params.trainer_id = filters.trainer_id;
    if (filters?.batch_id) params.batch_id = filters.batch_id;
    const { data } = await apiClient.get('/api/v1/admin/trainer-feedback', { params });
    return (data as TrainerFeedbackItem[]) ?? [];
  },
  getTrainerFeedbackSummary: async (): Promise<FeedbackSummary> => {
    const { data } = await apiClient.get('/api/v1/admin/trainer-feedback/summary');
    return (data as FeedbackSummary) ?? { trainers: [], batches: [] };
  },
};
